import { SERVICES } from 'api/common/constants';
import { gradeItemApi } from 'api/endpoints/GradeItem';
import { processedItemApi } from 'api/endpoints/ProcessedItem';
import { processedStageApi } from 'api/endpoints/ProcessedStage';
import { pulaFarmlandApi } from 'api/endpoints/PulaFarmland';
import { SalesOrderApi } from 'api/endpoints/SalesOrder';
import React from 'react';

const reportprobs = type => {
  const config = {
    farmland: {
      apiPath: '/farm/report',
      title: 'Farmland Report',
      fileName: 'FarmlandReport.xlsx',
      editPath: '/farmerReport/farmlandedit/',
      addPath: '/addCultivation/',
      editKey: 'id',
      exportKey: 'farmland_report',
      buttons: [
        {
          enabled: false,
          buttonName: 'Add Farm',
          redirectPath: '/farmerReport/create_farm'
        }
      ],
      dateFilter: true,
      responsive: true,
      cardTittles: [
        'Farmland Name',
        'Farmer Name',
        'Farmer ID',
        'Alternative Farmer Code',
        'Total Land Holding Area'
      ],
      service: SERVICES.DIGITIZATION
    },
    pulaFarmlandReport: {
      apiPath: '/farmland-report',
      title: 'Farmland Report',
      fileName: 'PulaFarmlandReport.xlsx',
      dateFilter: true,
      responsive: true,
      cardTittles: [
        'Farmland Name',
        'Farm ID',
        'Farmer Name',
        'Farmer ID',
        'Alternative Farmer Code',
        'Total Land Holding Area',
        'Farmer Contact Number',
        'Farm Status',
        'Farm Size',
        'Crop Variety',
        'Ownership Type',
        'Is Polygon Plotted',
        'Farmland Source',
        'Saved On'
      ],
      payloadmode: 'flat',
      service: SERVICES.PULA,
      exportKey: 'farmland_report',
      addPath: '/pula_integration/farmland/create/',
      editPath: '/pula_integration/farmland/edit/',
      editKey: 'id',
      statusUpdateFn: pulaFarmlandApi.updateFarmlandStatus,
      statusField: 'is_active',
      statusActiveValue: 'Active',
      idField: ['id'],
      buttons: [
        {
          enabled: true,
          buttonName: 'Add Farmland',
          redirectPath: '/pula_integration/farmland/create'
        },
        {
          enabled: true,
          buttonName: 'Check EUDR Status',
          action: 'pollEUDRStatus'
        }
      ]
    },
    perilAlerts: {
      apiPath: '/weather/peril/alert',
      fileName: 'PerilAlertReport.xlsx',
      title: 'Weather Peril Alerts',
      forWeather: true,
      dateFilter: false,
      district_ids: [],
      errorMsg: '"No Alerts for next 24 hours!"',
      service: SERVICES.DIGITIZATION
    },
    weatherAlertDashboard: {
      apiPath: '/weather/forcast',
      fileName: 'PerilAlertReport.xlsx',
      title: 'Peril Alert',
      forWeather: true,
      dateFilter: false,
      globalSearch: false,
      showHeader: false,
      showFooter: false,
      service: SERVICES.DIGITIZATION
    },
    perilAlertsDashboard: {
      apiPath: '/weather/peril/alert',
      fileName: 'PerilAlertReport.xlsx',
      title: 'Peril Alert',
      forWeather: true,
      dateFilter: false,
      globalSearch: false,
      showHeader: false,
      showFooter: false,
      limit: 3,
      errorMsg: '"No Alerts for next 24 hours!"',
      service: SERVICES.DIGITIZATION
    },
    farmerReport: {
      apiPath: '/farmer/report',
      title: 'Farmer Report',
      fileName: 'FarmerReport.xlsx',
      dateFilter: true,
      buttons: [
        {
          enabled: true,
          buttonName: 'Add Farmer',
          redirectPath: '/farmerReport/farmercreate'
        }
        // {
        //   enabled: true,
        //   buttonName: 'Farmer SMS',
        //   redirectPath: '/farmerReport/farmersms'
        // }
      ],
      editKey: 'id',
      editPath: '/farmerReport/farmeredit/',
      addPath: '/farmerReport/create_farm/',
      responsive: true,
      cardTittles: [
        'Farmer Name',
        'Farmer ID',
        'Alternative Farmer Code',
        'Gender',
        'Date Of Birth',
        'ID Type',
        'ID Proof Number',
        'Farm Status',
        'Block',
        'Village'
      ],
      service: SERVICES.DIGITIZATION
    },
    cultivationReport: {
      apiPath: '/cultivation/report',
      addPath: '/cultivation/harvest/',
      viewDetailsPath: '/cultivation/view/',
      title: 'Cultivation Report',
      editPath: '/cultivationReport/edit/',
      editKey: 'id',
      responsive: true,
      cardTittles: ['Farmer Name', 'Farm Name', 'Crop Name'],
      fileName: 'CultivationReport.xlsx',
      dateFilter: true,
      service: SERVICES.DIGITIZATION
    },
    smslogReport: {
      apiPath: '/farmer/sms/log',
      title: 'SMS Log Report',
      responsive: true,
      fileName: 'SMS Log Report.xlsx',
      dateRangePicker: true,
      service: SERVICES.DIGITIZATION
    },
    cropCalendarAlert: {
      apiPath: '/crop/calendar/alerts',
      title: 'Crop Calendar Report',
      fileName: 'CropCalendarFilterReport.xlsx',
      dropdownFilter: false,
      dateRangePicker: true,
      forInfection: false,
      service: SERVICES.DIGITIZATION
    },
    cropInfectionReport: {
      apiPath: '/crop_infection/alerts',
      title: 'Crop Infection Alerts',
      fileName: 'CropInfectionReport.xlsx',
      dropdownFilter: true,
      dateRangePicker: false,
      forInfection: true,
      service: SERVICES.DIGITIZATION
    },
    farmerGroupReport: {
      apiPath: '/farmer_group/report',
      title: 'Cooperative Report',
      fileName: 'FarmerGroupReport.xlsx',
      dateFilter: true,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Cooperative',
          redirectPath: '/farmerGroup'
        }
      ],
      editPath: '/farmerGroupReport/edit/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['Group Name', 'Entity/Organization Name', 'Active']
    },
    cropcalendarRuleReport: {
      apiPath: '/crop/calendar/report',
      title: 'Crop Calendar Rule Report',
      fileName: 'CropCalendarRuleReport.xlsx',
      dropdownFilter: false,
      cropFilter: true,
      dateRangePicker: false,
      forInfection: false,
      forCropCalendar: true,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Crop Calendar',
          redirectPath: '/cropcalendar'
        }
      ],
      service: SERVICES.DIGITIZATION
    },
    procurementReport: {
      apiPath: '/procurement/report',
      title: 'Procurement Report',
      fileName: 'procurementReport.xlsx',
      dropdownFilter: false,
      cropFilter: false,
      dateRangePicker: false,
      dateFilter: true,
      createPath: '/transfer',
      editPath: '/procurement/',
      editKey: ['id'],
      service: SERVICES.TRACEABILITY,
      globalSearchFilter: true,
      selection: true,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Procurement',
          redirectPath: '/procurement'
        },
        {
          enabled: true,
          buttonName: 'Create Transfer',
          action: 'multi_transfer',
          redirectPath: '/transfer'
        }
      ],
      responsive: true,
      cardTittles: [
        'Procured On',
        'Procurement ID',
        'Crop',
        'Variety',
        'Grade',
        'Procured at',
        'Total Amount (UGX)',
        'Moisture Content',
        'Procurement Status'
      ]
    },
    marketpriceReport: {
      apiPath: '/marketprice/report',
      title: 'Market Price Report',
      fileName: 'MarketPriceReport.xlsx',
      dropdownFilter: false,
      cropFilter: false,
      dateRangePicker: false,
      forInfection: false,
      forCropCalendar: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Market Price',
          redirectPath: '/marketprice'
        }
      ],
      responsive: true,
      cardTittles: ['Market/Mandi Name', 'Village', 'Approval Status'],
      service: SERVICES.DIGITIZATION
    },
    centerList: {
      apiPath: '/center/report',
      title: 'Center List',
      fileName: 'CenterList.xlsx',
      dropdownFilter: true,
      dropdownData: [
        {
          key: 'block_ids',
          label: 'Select City',
          isMulti: true,
          apiPath: '/center/block_list'
        },
        {
          key: 'center_function',
          label: 'Select Function Type',
          isMulti: true,
          apiPath: '/center/function_type'
        }
      ],
      payloadmode: 'flat',
      dateRangePicker: false,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Center',
          redirectPath: '/processingCenter'
        }
      ],
      editPath: '/processingCenter/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['Center Name', 'Center Function', 'Village']
    },
    transferReport: {
      apiPath: '/transfer/report',
      title: 'Transfer Report',
      fileName: 'TransferReport.xlsx',
      dropdownFilter: false,
      cropFilter: false,
      dateRangePicker: false,
      dateFilter: true,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      payloadmode: 'flat',
      selection: true,
      globalSearchFilter: true,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Reception',
          action: 'CREATE_RECEPTION',
          redirectPath: '/reception'
        }
      ],
      responsive: true,
      createPath: '/reception',
      editPath: '/transfer/',
      editKey: ['id'],
      cardTittles: [
        'Transfer ID',
        'Transfer Date',
        'Transfer Type',
        'source',
        'destination',
        'Transfer Status'
      ]
    },
    receptionReport: {
      apiPath: '/reception/report',
      title: 'Reception Report',
      fileName: 'ReceptionReport.xlsx',
      payloadmode: 'flat',
      dateFilter: true,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      dropdownFilter: false,
      buttons: [],
      editPath: '/reception/',
      editKey: ['id'],
      responsive: true,
      cardTittles: [
        'Batch ID',
        'Reception Date',
        'Reception Center Type',
        'Reception Center',
        'StockIn Quantity'
      ]
    },
    processReport: {
      apiPath: '/process/report',
      title: 'Process Report',
      fileName: 'ProcessReport.xlsx',
      payloadmode: 'flat',
      dateFilter: true,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      dropdownFilter: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Process',
          redirectPath: '/process'
        }
      ],
      editPath: '/process/',
      editKey: ['id'],
      responsive: true,
      cardTittles: [
        'Process ID',
        'process date',
        'facility name',
        'input items',
        'process',
        'output'
      ]
    },
    processedItemReport: {
      apiPath: '/processed_item/report',
      title: 'Process Item Report',
      fileName: 'ProcessItemReport.xlsx',
      payloadmode: 'flat',
      dateFilter: false,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      dropdownFilter: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Processed Item',
          redirectPath: '/processedItem'
        }
      ],
      editPath: '/processedItem/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['product_name', 'Gen Product List Code'],
      statusUpdateFn: processedItemApi.updateProcessedItemStatus,
      statusField: 'is_active',
      idField: ['id']
    },
    processedStageReport: {
      apiPath: '/processed_stage/report',
      title: 'Process Stage Report',
      fileName: 'ProcessStageReport.xlsx',
      payloadmode: 'flat',
      dateFilter: false,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      dropdownFilter: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Processed Stage',
          redirectPath: '/processedStage'
        }
      ],
      editPath: '/processedStage/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['stage name', 'code'],
      statusUpdateFn: processedStageApi.updateProcessedStageStatus,
      statusField: 'is_active',
      idField: ['id']
    },
    gradeItemReport: {
      apiPath: '/grade_item/report',
      title: 'Grade Item Report',
      fileName: 'GradeReport.xlsx',
      payloadmode: 'flat',
      dateFilter: false,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      dropdownFilter: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Grade Item',
          redirectPath: '/gradeItem'
        }
      ],
      editPath: '/gradeItem/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['Grade name'],
      statusUpdateFn: gradeItemApi.updateGradeItemStatus,
      statusField: 'is_active',
      idField: ['id']
    },
    traceabilityUserReport: {
      apiPath: '/user/report',
      title: 'Traceability User Report',
      fileName: 'TraceabilityUserReport.xlsx',
      payloadmode: 'flat',
      dateFilter: false,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.TRACEABILITY,
      dropdownFilter: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Traceability User',
          redirectPath: '/traceabilityUser'
        }
      ],
      editPath: '/traceabilityUser/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['Username', 'Phone Number', 'Organization'],
      statusField: 'is_active',
      idField: ['id']
    },
    cropItemReport: {
      apiPath: '/crop/report',
      title: 'Crop Item Report',
      fileName: 'CropReport.xlsx',
      payloadmode: 'flat',
      dateFilter: false,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.DIGITIZATION,
      dropdownFilter: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Crop Item',
          redirectPath: '/cropItem'
        }
      ],
      editPath: '/cropItem/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['Crop name'],
      statusField: 'is_active',
      idField: ['id']
    },
    cropVarietyItemReport: {
      apiPath: '/crop_variety/report',
      title: 'Crop Variety Item Report',
      fileName: 'CropVarietyReport.xlsx',
      payloadmode: 'flat',
      dateFilter: false,
      forInfection: false,
      forCropCalendar: false,
      service: SERVICES.DIGITIZATION,
      dropdownFilter: true,
      dropdownData: [
        {
          apiPath: '/crop/list',
          key: 'crop_id',
          name: 'Crop',
          isMulti: true
        }
      ],
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Crop Variety Item',
          redirectPath: '/cropVarietyItem'
        }
      ],
      editPath: '/cropVarietyItem/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['Crop name', 'Variety'],
      statusField: 'is_active',
      idField: ['id']
    },
    fieldOfficerReport: {
      apiPath: '/field_officer/report',
      title: 'Trader Report',
      fileName: 'FieldofficerReport.xlsx',
      dropdownFilter: false,
      dateRangePicker: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Trader',
          redirectPath: '/fieldOfficerReport/fieldOfficerCreate'
        }
      ],
      editPath: '/fieldOfficerReport/fieldOfficerEdit/',
      editKey: ['id'],
      responsive: true,
      cardTittles: [
        'Field officer Id',
        'First Name',
        'Last Name',
        'Phone Number',
        'Organization'
      ]
    },
    moduleReport: {
      apiPath: '/module/report',
      title: 'Module Report',
      fileName: 'ModuleReport.xlsx',
      dropdownFilter: false,
      dateRangePicker: false,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Module',
          redirectPath: '/module/'
        }
      ],
      editPath: '/module/',
      editKey: ['id'],
      responsive: true,
      cardTittles: ['Tenant', 'Module', 'Screens']
    },
    ExportReportsPage: {
      apiPath: '/export/export_log_report',
      title: 'View All Export Data',
      responsive: true,
      cardTittles: ['Report Name', 'Action']
    },
    createProduct: {
      apiPath: '/marketplace/product/create',
      title: 'Create Product',
      service: SERVICES.DIGITIZATION
    },
    productCatalog: {
      apiPath: '/marketplace/product/catalog',
      title: 'My Product Catalog',
      service: SERVICES.DIGITIZATION
    },
    manageWarehouses: {
      apiPath: '/marketplace/warehouses',
      title: 'Manage Warehouses',
      service: SERVICES.DIGITIZATION
    },
    stockInReport: {
      dateFilter: true,
      apiPath: '/stock-in/report',
      title: 'Stock In Report',
      fileName: 'StockInReport.xlsx',
      responsive: true,
      service: SERVICES.DIGITIZATION,
      buttons: [
        {
          enabled: true,
          buttonName: 'Stock In Entry',
          redirectPath: '/create-stock-in'
        }
      ],
      editPath: '/create-stock-in/',
      editKey: 'id',
      cardTittles: [
        'Stock In Code',
        'Stock In Date',
        'Organization',
        'Warehouse',
        'Ref No',
        'Total Items',
        'Total Quantity',
        'Total Value (UGX)',
        'Status',
        'Created On'
      ]
    },
    stockReport: {
      apiPath: '/marketplace/stock-report',
      title: 'My Stock Report',
      service: SERVICES.DIGITIZATION
    },
    myOrders: {
      apiPath: '/marketplace/orders',
      title: 'My Orders',
      service: SERVICES.DIGITIZATION
    },
    ordersProductReport: {
      apiPath: '/marketplace/orders-product-report',
      title: 'My Orders Product Report',
      service: SERVICES.DIGITIZATION
    },
    manageFulfillmentUser: {
      apiPath: '/marketplace/fulfillment-users',
      title: 'Manage Fulfillment User',
      service: SERVICES.DIGITIZATION
    },
    orderReturns: {
      apiPath: '/marketplace/order-returns',
      title: 'Order Returns',
      service: SERVICES.DIGITIZATION
    },
    stockTransfer: {
      dateFilter: true,
      apiPath: '/stock-transfer/report',
      title: 'Stock Transfer Report',
      fileName: 'StockTransferReport.xlsx',
      responsive: true,
      service: SERVICES.DIGITIZATION,
      buttons: [
        {
          enabled: true,
          buttonName: 'Stock Transfer Entry',
          redirectPath: '/create-stock-transfer'
        }
      ],
      editPath: '/create-stock-transfer/',
      editKey: 'id',
      cardTittles: [
        'Transfer Code',
        'Transfer Date',
        'From Organization',
        'From Warehouse',
        'To Organization',
        'To Warehouse',
        'Ref No',
        'Total Items',
        'Total Quantity',
        'Total Value (UGX)',
        'Status',
        'Created On'
      ]
    },
    consolidatedOrderHistory: {
      apiPath: '/marketplace/consolidated-orders',
      title: 'Consolidated Order History',
      service: SERVICES.DIGITIZATION
    },
    createSalesOrder: {
      apiPath: '/marketplace/sales-order/create',
      title: 'Create Sales Order',
      service: SERVICES.DIGITIZATION
    },
    marketplaceSalesOrderReport: {
      apiPath: '/marketplace/sales-order/report',
      title: 'Sales Order Report',
      service: SERVICES.DIGITIZATION
    },
    createCategory: {
      apiPath: '/marketplace/category/create',
      title: 'Create Category',
      service: SERVICES.DIGITIZATION
    },
    categoryReport: {
      dateFilter: true,
      apiPath: '/category/report',
      title: 'Category',
      fileName: 'CategoryReport.xlsx',
      responsive: true,
      service: SERVICES.DIGITIZATION,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Category',
          redirectPath: '/create-category'
        }
      ],
      editPath: '/create-category/',
      editKey: 'id',
      cardTittles: [
        'Category Name',
        'Parent Category',
        'Description',
        'Sort Order',
        'Status',
        'Created On'
      ]
    },
    productReport: {
      dateFilter: true,
      apiPath: '/product/report',
      title: 'Products',
      fileName: 'ProductReport.xlsx',
      responsive: true,
      service: SERVICES.DIGITIZATION,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Product',
          redirectPath: '/create-product'
        }
      ],
      editPath: '/create-product/',
      editKey: 'id',
      cardTittles: [
        'Product Name',
        'SKU',
        'Category',
        'Input Type',
        'Price',
        'UOM',
        'Status',
        'Created On'
      ]
    },
    supplierReport: {
      dateFilter: true,
      apiPath: '/supplier/report',
      title: 'Suppliers',
      fileName: 'SupplierReport.xlsx',
      responsive: true,
      service: SERVICES.DIGITIZATION,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Supplier',
          redirectPath: '/create-supplier'
        }
      ],
      editPath: '/create-supplier/',
      editKey: 'id',
      cardTittles: [
        'Supplier Name',
        'Contact Person',
        'Address',
        'Phone Contact',
        'Email',
        'Created On'
      ]
    },
    customerReport: {
      dateFilter: true,
      apiPath: '/customer/report',
      title: 'Customers',
      fileName: 'CustomerReport.xlsx',
      responsive: true,
      service: SERVICES.DIGITIZATION,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Customer',
          redirectPath: '/create-customer'
        }
      ],
      editPath: '/create-customer/',
      editKey: 'id',
      cardTittles: [
        'Customer Name',
        'Contact Person',
        'Country',
        'District',
        'Sub County',
        'Parish',
        'Village',
        'National ID',
        'Gender',
        'DOB',
        'Pin Location',
        'Created On'
      ]
    },
    addPromos: {
      apiPath: '/marketplace/promos',
      title: 'Add Promos',
      service: SERVICES.DIGITIZATION
    },
    purchaseOrderRequest: {
      apiPath: '/marketplace/purchase-order/request',
      title: 'Purchase Order Request',
      service: SERVICES.DIGITIZATION
    },
    purchaseOrder: {
      dateFilter: true,
      apiPath: '/purchase-order/report',
      title: 'Purchase Order Report',
      fileName: 'PurchaseOrderReport.xlsx',
      responsive: true,
      service: SERVICES.DIGITIZATION,
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Purchase Order',
          redirectPath: '/create-purchase-order'
        }
      ],
      editPath: '/create-purchase-order/',
      editKey: 'id',
      cardTittles: [
        'PO Code',
        'PO Date',
        'Supplier',
        'Warehouse',
        'Delivery Date',
        'Payment Mode',
        'Payment Duration',
        'Total Items',
        'Total Qty',
        'Total Value (UGX)',
        'Status',
        'Created On'
      ]
    },
    stockReturn: {
      dateFilter: true,
      apiPath: '/stock-return/report',
      title: 'Stock Return Report',
      fileName: 'StockReturnReport.xlsx',
      responsive: true,
      service: SERVICES.DIGITIZATION,
      buttons: [
        {
          enabled: true,
          buttonName: 'Stock Return Entry',
          redirectPath: '/create-stock-return'
        }
      ],
      editPath: '/create-stock-return/',
      editKey: 'id',
      cardTittles: [
        'Return Code',
        'Return Date',
        'Warehouse',
        'PO / Invoice No',
        'Supplier',
        'Customer',
        'Ref No',
        'Total Items',
        'Total Qty',
        'Total Value (UGX)',
        'Status',
        'Created On'
      ]
    },
    distributionPartnerManagement: {
      apiPath: '/marketplace/distribution-partners',
      title: 'Distribution Partner Management',
      service: SERVICES.DIGITIZATION
    },
    salesOrderReport: {
      title: 'Sales Order Report',
      apiPath: '/sales_order/report',
      fileName: 'SalesOrderReport.xlsx',
      fetchReportApi: SalesOrderApi.salesOrderReport,
      reportPath: `/salesOrderReport`,
      createPath: `/salesOrder`,
      editPath: '/salesOrder/',
      editKey: 'id',
      service: SERVICES.TRACEABILITY,
      responsive: true,
      selection: false,
      globalSearchFilter: true,
      cardTittles: [
        'Gen Sales Order Code',
        'Order Date',
        'Crop',
        'Organization',
        'Trader',
        'Payment Method',
        'Grand Total'
      ],
      buttons: [
        {
          enabled: true,
          buttonName: 'Create Sales Order',
          redirectPath: '/salesOrder'
        }
      ]
    }
  };

  return config[type] || {};
};

export default reportprobs;
